import React from 'react'
import { Steps } from 'antd'
import { CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { IStepProps } from './ContentStep'

interface IProps {
	loading: boolean
	error: boolean

	currentStepId: number
	children: React.ReactElement<IStepProps>[]
}

type Status = 'wait' | 'process' | 'finish' | 'error' | undefined

function getStatus(
	id: number,
	currentId: number,
	error: boolean
): Status {
	if (id === currentId) {
	    return 'process'
	}

	if (error && id === currentId) {
	    return 'error'
	}

	if (id < currentId) {
	    return 'finish'
	}

	if (id > currentId) {
	    return 'wait'
	}

	return void 0
}

function getIcon(originalIcon: React.ReactNode, status: Status, id: number, currentId: number, loading: boolean) {
	if (loading && status === 'process') {
		return <LoadingOutlined/>
	}
	if (status === 'finish') {
		return <CheckCircleOutlined/>
	}

	return originalIcon

}

export const ContentSteps = (props: IProps): React.ReactElement => (
	<div>
		<Steps>
			{React.Children.map(props.children, (child, index) => {
			    const status = getStatus(
					index, props.currentStepId, props.error
				)

				return (
					<Steps.Step
						title={child.props.title}
						icon={getIcon(child.props.icon, status, index, props.currentStepId, props.loading)}
						status={status}
					/>
				)
			})}
		</Steps>

		<div style={{ marginTop: '4%' }}>
			{props.children[props.currentStepId] ?
				props.children[props.currentStepId]?.props.children : <></>}
		</div>
	</div>
)
